export default __webpack_public_path__ + "static/media/nogiftcard.3cbb5c07.jpg";